import React from 'react';

import {ListboxGroup} from '@pb/kit-component-listbox';

import type {ListboxGroupProps} from '@pb/kit-component-listbox';

export const ComboboxGroup = (props: ListboxGroupProps) => {
    return <ListboxGroup {...props}/>;
};

ComboboxGroup.displayName = 'ComboboxGroup';
